const initialState = window.__STATE__.premiumQuotes || {};

export default function reducer(state = initialState, action) {
  return state
}
